import { breakpointGreaterThanEquals } from "../lib/appearance";
import { wrap } from "../lib/utilities";

/**
 * Add a line through to all paragraphs of a element if you hover a anchor inside the element except the hovered anchor.
 *
 * <div class="line-through-hover">
 *    <p>First paragraph lorem ipsum dolor <a href="#">Link</a> sit amet.</p>
 *    <p>Second paragraph lorem <a href="#">Link</a> ipsum dolor sit amet.</p>
 * </div>
 */
window.addEventListener("DOMContentLoaded", () => {
   if (breakpointGreaterThanEquals("md")) {
      // Wrap each word in each paragraph with a div
      Array.from(document.querySelectorAll(".line-through-hover")).forEach(element => {
         Array.from(element.childNodes).forEach(childElement => {
            Array.from(childElement.childNodes).forEach(node => {
               if (node.nodeType === Node.TEXT_NODE) {
                  const words = node.nodeValue.trim().split(" ");
                  const fragment = document.createDocumentFragment();

                  for (let i = 0; i < words.length; i++) {
                     const word = words[i];
                     const wrapper = wrap(word, "div", "segment");

                     fragment.appendChild(wrapper);

                     if (i !== words.length - 1) {
                        wrapper.appendChild(document.createTextNode(" "));
                     }
                  }

                  if (node.nextElementSibling && node.nextElementSibling.tagName === "A") {
                     fragment.appendChild(node.nextElementSibling);
                  }

                  node.parentNode.removeChild(node);
                  childElement.appendChild(fragment);
               }
            });
         });

         Array.from(element.querySelectorAll("a")).forEach(trigger => {
            trigger.classList.add("trigger");

            trigger.addEventListener("mouseenter", () => {
               trigger.classList.add("is-active");
               element.classList.add("is-active");
            });

            trigger.addEventListener("mouseleave", () => {
               trigger.classList.remove("is-active");
               element.classList.remove("is-active");
            });
         });
      });
   }
});
